import { FlatList } from 'react-native-gesture-handler';
import type { GoodsDetailContentKeys } from '../types/GoodsDetailContentKeys';
import Animated from 'react-native-reanimated';
export const AnimatedList = Animated.createAnimatedComponent(
  FlatList<GoodsDetailContentKeys>,
);
